import {
  LOGIN_ENDPOINTS,
  LOGIN_EVARTAI_LOGIN,
  LOGIN_VILNIUS_LOGIN,
} from '../constants/api';
import { storeLoginVerifier } from './login-verifier';

export const loginForm = (loginMethod: string): HTMLFormElement | void => {
  const form = document.createElement('form');
  if (loginMethod === LOGIN_VILNIUS_LOGIN) {
    form.action = `${process.env.REACT_APP_API_URL}${LOGIN_ENDPOINTS.LOGIN_VILNIUS_LOGIN}`;
  } else if (loginMethod === LOGIN_EVARTAI_LOGIN) {
    form.action = `${process.env.REACT_APP_API_URL}${LOGIN_ENDPOINTS.LOGIN_EVARTAI_LOGIN}`;
  } else {
    return;
  }
  form.method = 'POST';

  const redirectUrlInput = document.createElement('input');
  redirectUrlInput.name = 'redirectUrl';
  redirectUrlInput.value = window.location.origin + '/authorized';
  form.appendChild(redirectUrlInput);

  const clientKeyInput = document.createElement('input');
  clientKeyInput.name = 'clientKey';
  clientKeyInput.value = process.env.REACT_APP_CLIENT_KEY as string;
  form.appendChild(clientKeyInput);

  // Both login methods return to /authorized, so both must carry a verifier;
  // otherwise the callback handler rejects the flow as a stale session.
  const loginVerifierInput = document.createElement('input');
  loginVerifierInput.name = 'loginVerifier';
  loginVerifierInput.value = storeLoginVerifier();
  form.appendChild(loginVerifierInput);

  return form;
};
